import useRootStore from './useRootStore';

export default function useAuth() {
  const { authStore } = useRootStore();
  return authStore;
}
